import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/angular_gradient.svg'
import _imports_1 from '../assets/js_logo.svg'
import _imports_2 from '../assets/my_sql.svg'
import _imports_3 from '../assets/css3.svg'
import _imports_4 from '../assets/html5.svg'
import _imports_5 from '../assets/bootstrap_5_logo.svg'


const _hoisted_1 = { class: "skills-section d-flex flex-column justify-content-space-around fade-out-element align-items-center" }

import BaseList from './BaseList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HabilitiesSection',
  setup(__props) {

const habilites: string[] = [
    'trabajo en equipo',
    'responsable',
    'rapido aprendizaje',
    'iniciativa y compromiso',
]

const tools1: string[] = [
    'GIT',
    'HTML5',
    'CSS3',
    'JavaScript',
    'VueJs',
    'Angular',
]

const tools2: string[] = [
    'MySQL',
    'Bootstrap 5',
    'COBOL74',
    'DASDL',
    'Web Enabler',
    'ClearPath MCP',
]



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "inter-500 linear-gradient-black-to-green-2 text-1" }, "Herramientas y Habilidades", -1)),
    _createVNode(BaseList, { "list-items": habilites }),
    _createVNode(BaseList, { "list-items": tools1 }),
    _createVNode(BaseList, { "list-items": tools2 }),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"icons-container justify-content-space-around\" data-v-87fea5b4><figure class=\"btn-animated brand-text\" data-v-87fea5b4><img src=\"" + _imports_0 + "\" alt=\"Angular\" data-v-87fea5b4></figure><figure class=\"btn-animated\" data-v-87fea5b4><img src=\"" + _imports_1 + "\" alt=\"JavaScript\" data-v-87fea5b4></figure><figure class=\"btn-animated\" data-v-87fea5b4><img src=\"" + _imports_2 + "\" alt=\"MySQL\" data-v-87fea5b4></figure><figure class=\"btn-animated\" data-v-87fea5b4><img src=\"" + _imports_3 + "\" alt=\"CSS3\" data-v-87fea5b4></figure><figure class=\"btn-animated\" data-v-87fea5b4><img src=\"" + _imports_4 + "\" alt=\"HTML5\" data-v-87fea5b4></figure><figure class=\"btn-animated\" data-v-87fea5b4><img src=\"" + _imports_5 + "\" alt=\"Bootstrap 5\" data-v-87fea5b4></figure></div>", 1))
  ]))
}
}

})